define([
    "base/utils/iamHttpService",
    "language/resource",
    "authui/iamUtils"
], function (iamHttpService, i18n, iamUtils) {
    "use strict";

    var ctrl = function ($scope, $compile) {
        document.title = i18n("titles.welcomeEmail");
        $scope.i18n = i18n;
        $scope.model = {
        };

        $scope.resendEmail = function() {
            iamHttpService.post({
                url: "/rest/authui/welcome/resendEmail",
                mask: true
            }).then(function (data) {
                if(data.retinfo === "success") {
                    iamUtils.MESSAGE.PROMPT(i18n("welcomeEmail.alreadySend"), "", "popupMsg");
                } else if (data.retinfo === "failed"){
                    iamUtils.MESSAGE.ERROR(i18n("sendFailed"), "", "popupMsg");
                } else {
                    redirect2Login();
                }
            }, function (data) {
                iamUtils.MESSAGE.ERROR(i18n("sendFailed"), "", "popupMsg");
            });
        }

        function redirect2Login()
        {
            var service = iamUtils.getUrlParams()["service"];
            if (service) {
                window.location.href = "/authui/?locale=" + window.language + "&service=" + iamUtils.getUrlParams()["service"];
            }else {
                window.location.href = "/authui/?locale=" + window.language;
            }
        }

        $("#failedContainer").css({"background-color":"#F4F4F4", "margin-top": "100px"});
        $("#failedContent").css("background-color","#F4F4F4");
    };

    ctrl = ["$scope", "$compile", ctrl];
    var loginModule = angular.module('authui.config');
    loginModule.controller("authui.welEmailResend.ctrl", ctrl);

    return ctrl;
});



// WEBPACK FOOTER //
// ./public/hws/js/welcomeemail/controllers/resendController.js